/**
 *
 * @author Teresa Ocampo
 * @company Erillam Healthcare
 * @version 1.0
 *
 */

import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class PersonalTypeRequest extends MainRequest{

    static addPersonalType(data) {
        return this.postSEC(ServicePath.PERSONAL_TYPE_ADD, data);
    }

    static listAllPersonalType() {
        return this.getSEC(ServicePath.PERSONAL_TYPE_LIST);
    }
    static findPersonalType(data) {
        return this.postSEC(ServicePath.PERSONAL_TYPE_FIND, data)
    }
    static update(object) {
        return this.postSEC(ServicePath.PERSONAL_TYPE_UPDATE, object);
    }


}